export default __webpack_public_path__ + "static/media/money-bags.be4e3508.svg";